"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var input_mapping_const_1 = require("@const/input.mapping.const");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var helper_const_1 = require("@src/const/helper.const");
var reference_object_const_1 = require("@src/const/reference-object.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var get_1 = __importDefault(require("lodash/get"));
var api_wrapper_1 = require("../../../api/api-wrapper");
var element_generator_1 = require("../../../element-generator");
var yond_finish_service_1 = require("../membership-completion/services/yond-finish.service");
var backend_services_1 = require("@src/services/backend-services");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var tracker_service_1 = require("@src/services/tracker.service");
var studio_selection_util_1 = require("./studio-selection.util");
var translation_1 = __importDefault(require("@src/services/translation"));
var studio_selection_map_1 = require("./studio-selection.map");
var ip_resolvement_service_1 = require("@src/services/ip-resolvement.service");
var Location = /** @class */ (function () {
    function Location() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.elementGenerator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.yondFinishService = object_service_1.ObjectService.getInstance(yond_finish_service_1.YondFinishService);
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.trackerService = object_service_1.ObjectService.getInstance(tracker_service_1.TrackerService);
        this.backupStudios = [];
        this.listStudios = [];
        this.studios = [];
        this.maxSearchResults = 40;
        this.maxShowedSearchResults = 5;
        this.maxShowedStudios = 3;
        this.stylesAdded = false;
        this.studioTagTemplateReferences = new Map();
        this.openStreetMapResults = '#search-results-wrapper';
    }
    Location.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var studios, pos, searchBar;
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0:
                        this.initializeStudioTagTemplateReferences();
                        this.addStyle();
                        console.log('container:', this.$container);
                        if ((_a = this.config.get.location) === null || _a === void 0 ? void 0 : _a.map) {
                            this.validateMapSynchronization();
                            this.studioSelectionMap = new studio_selection_map_1.StudioSelectionMap(this);
                            this.studioSelectionMap.events$.subscribe(function (a) {
                                if (a.action === 'viewChange' && (a === null || a === void 0 ? void 0 : a.filteredStudios)) {
                                    _this.filterStudios(a.filteredStudios);
                                }
                                else if (a.action === 'clicked' && a.studio) {
                                    void _this.selectStudio(a.studio, {
                                        continueToNextStep: false,
                                        event: a.event,
                                    }).catch(function (error) { return console.error('Map studio selection failed', error); });
                                }
                            });
                        }
                        return [4 /*yield*/, this.apiWrapper.getStudios()];
                    case 1:
                        studios = _o.sent();
                        if (((_c = (_b = this.config.get) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.additionalStudios) && ((_f = (_e = (_d = this.config.get) === null || _d === void 0 ? void 0 : _d.location) === null || _e === void 0 ? void 0 : _e.additionalStudios) === null || _f === void 0 ? void 0 : _f.length)) {
                            studios = studios.concat(this.config.get.location.additionalStudios);
                        }
                        this.backupStudios = (0, studio_selection_util_1._ManipulateStudioDataBeforeUse)(this.config, studios);
                        return [4 /*yield*/, (0, ip_resolvement_service_1._ResolveIpToGPS)()];
                    case 2:
                        pos = _o.sent();
                        if (pos) {
                            this.userLatitude = pos.latitude;
                            this.userLongitude = pos.longitude;
                        }
                        // Sets the initial count e.g. sometimes we want to show by default only 5 studios
                        if ((_h = (_g = this.config.get) === null || _g === void 0 ? void 0 : _g.location) === null || _h === void 0 ? void 0 : _h.initialStudioCount) {
                            this.maxShowedStudios = +this.config.get.location.initialStudioCount;
                        }
                        //If not explicitly deactivated by settings we try to get user location by coordinates
                        if (!(((_k = (_j = this.config.get) === null || _j === void 0 ? void 0 : _j.location) === null || _k === void 0 ? void 0 : _k.userGpsTracking) === false)) {
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition(function (position) {
                                    _this.userLatitude = +position.coords.latitude;
                                    _this.userLongitude = +position.coords.longitude;
                                    _this.filterStudiosByDistance();
                                });
                            }
                            else {
                                console.log('Geolocation is not supported by this browser.');
                            }
                        }
                        //hide ref objects in v2 probably no longer needed
                        // [
                        //   this.config.get?.location?.searchResultRefObject,
                        //   this.config.get?.location?.showMoreRefObject,
                        // ].forEach((a) => $('#' + a).css('display', 'none'));
                        if (this.config.get.environment === 'dev') {
                            console.info('If you want to use directly the magicline studio object just define some parent object as [data-location="<<LOCATION-ID>>"]', 'And than you can use in the children e.g. custom attributes like [data-get="distanceToUser"]');
                        }
                        searchBar = (_m = (_l = this.module.references) === null || _l === void 0 ? void 0 : _l.locationSearch) === null || _m === void 0 ? void 0 : _m.domElement;
                        if (searchBar === null || searchBar === void 0 ? void 0 : searchBar.length) {
                            searchBar.on('keydown', function (event) {
                                if (event.key === 'Enter' || event.keyCode === 13) {
                                    event.stopImmediatePropagation();
                                    event.preventDefault();
                                }
                            });
                            searchBar.on('keyup', (0, debounce_1.default)(function (event) {
                                var search = event.target.value;
                                if (search.length > 3 && search !== _this.lastSearch) {
                                    _this.getUserLocationByInput(search);
                                }
                            }, 300));
                        }
                        else {
                            console.error('No location search bar found');
                        }
                        // workaround because only references of the first 3 studios will be loaded
                        // if a reference is not used within the first 3, it stays visible
                        (0, cash_dom_1.default)('[data-ref^="location-reference-"]').each(function () {
                            (0, cash_dom_1.default)(this).attr('style', ((0, cash_dom_1.default)(this).attr('style') || '') + ';display: none !important;');
                        });
                        this.filterStudiosByDistance();
                        return [2 /*return*/];
                }
            });
        });
    };
    Location.prototype.getUserLocationByInput = function (input) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        // TODO: remove legacy
        if ((0, cash_dom_1.default)(this.openStreetMapResults).length || ((_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.searchResultsWrapper) === null || _b === void 0 ? void 0 : _b.domElement)) {
            // LEGACY !!!!
            if (this.config.get.section !== 'v2') {
                (0, cash_dom_1.default)(this.openStreetMapResults).html('');
                (0, cash_dom_1.default)(this.openStreetMapResults).append((0, generator_const_1._GetComponentLoadingSpinner)());
            }
            else if ((_d = (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.searchResultsWrapper) === null || _d === void 0 ? void 0 : _d.domElement) {
                this.module.references.searchResultsWrapper.domElement.html('');
                this.module.references.searchResultsWrapper.domElement.append((0, generator_const_1._GetComponentLoadingSpinner)());
            }
            this.lastSearch = input;
            var url = 'https://nominatim.openstreetmap.org/search?q=' + input + '&format=json&limit=' + this.maxSearchResults;
            (0, backend_services_1.betterFetch)(url)
                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                var data, sortedLocations;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, response.json()];
                        case 1:
                            data = _a.sent();
                            if (data.length > 0) {
                                sortedLocations = (0, studio_selection_util_1._SortOSMDataByStudios)(data, this.backupStudios);
                                this.generateUserLocationsList(sortedLocations);
                            }
                            else {
                                this.generateUserLocationsList([]);
                            }
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (error) {
                console.log('An error occurred: ', error);
                (0, generator_const_1._DeleteLoadingScreen)();
            });
        }
        else if (this.config.get.environment === 'dev') {
            console.error('No wrapper for openstreetmap results please use id: ', this.openStreetMapResults, 'or data-ref', (_f = (_e = this.module.references) === null || _e === void 0 ? void 0 : _e.searchResultsWrapper) === null || _f === void 0 ? void 0 : _f.uid);
        }
    };
    Location.prototype.generateUserLocationsList = function (locations) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var locationHTML = [];
        var counter = 0;
        var _loop_1 = function (location_1) {
            if (counter > this_1.maxShowedSearchResults) {
                return "continue";
            }
            counter++;
            var jqueryObject = void 0;
            if ((_b = (_a = this_1.config.get) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.searchResultRefObject) {
                // jqueryObject = this.helper.createClonesForRefObjectId(
                //   [{ key: 'data-user-location', value: location.display_name }],
                //   '#' + this.config.get.location.searchResultRefObject
                // );
                // jqueryObject.find('[data-get]').each((i, el) => {
                //   if (el.getAttribute('data-get') === 'display_name') {
                //     el.innerHTML = location.display_name;
                //   }
                // });
            }
            else {
                var html = "\n        <div style=\"display:flex;flex-direction:column\">\n          <strong>".concat(location_1.display_name, "</strong>\n        </div>\n        <div>").concat(translation_1.default.t('Your location'), "</div>");
                jqueryObject = this_1.elementGenerator.getRow({
                    html: html,
                    class: 'search-result-picker',
                });
                locationHTML.push(jqueryObject.on('click', function () {
                    var _a, _b;
                    if (_this.config.get.section === 'v2' && ((_b = (_a = _this.module.references) === null || _a === void 0 ? void 0 : _a.searchResultsWrapper) === null || _b === void 0 ? void 0 : _b.domElement)) {
                        _this.module.references.searchResultsWrapper.domElement.html('');
                    }
                    else {
                        (0, cash_dom_1.default)(_this.openStreetMapResults).html('');
                    }
                    _this.userLatitude = +location_1.lat;
                    _this.userLongitude = +location_1.lon;
                    _this.filterStudiosByDistance();
                }));
            }
        };
        var this_1 = this;
        for (var _i = 0, locations_1 = locations; _i < locations_1.length; _i++) {
            var location_1 = locations_1[_i];
            _loop_1(location_1);
        }
        if (this.config.get.section === 'v2' && ((_d = (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.searchResultsWrapper) === null || _d === void 0 ? void 0 : _d.domElement)) {
            this.module.references.searchResultsWrapper.domElement.html('');
            for (var _g = 0, locationHTML_1 = locationHTML; _g < locationHTML_1.length; _g++) {
                var el = locationHTML_1[_g];
                this.module.references.searchResultsWrapper.domElement.append(el);
            }
        }
        else {
            (0, cash_dom_1.default)(this.openStreetMapResults).html('');
            for (var _h = 0, locationHTML_2 = locationHTML; _h < locationHTML_2.length; _h++) {
                var el = locationHTML_2[_h];
                (0, cash_dom_1.default)(this.openStreetMapResults).append(el);
            }
        }
        // show more
        var showMoreButton = this.createLocationSearchShowMoreButton(locations);
        if (showMoreButton && ((_f = (_e = this.module.references) === null || _e === void 0 ? void 0 : _e.searchResultsWrapper) === null || _f === void 0 ? void 0 : _f.domElement)) {
            this.module.references.searchResultsWrapper.domElement.append(showMoreButton);
        }
        (0, generator_const_1._DeleteLoadingScreen)();
    };
    Location.prototype.fireChangeEvent = function () {
        var locationChangedEvent = new CustomEvent('locationChanged', {
            detail: {
                filteredStudios: this.studios,
                studios: this.backupStudios,
                latitude: this.userLatitude,
                longitude: this.userLongitude,
            },
        });
        document.dispatchEvent(locationChangedEvent);
    };
    Location.prototype.fireSelectionEvent = function (detail) {
        var selectionEvent = new CustomEvent('locationSelected', {
            detail: detail,
        });
        document.dispatchEvent(selectionEvent);
    };
    /** Adds the distance to the user for each studio and sorts it by distance */
    Location.prototype.filterStudiosByDistance = function () {
        this.resetListStudios();
        this.updateRenderedStudios();
    };
    /** Applies the current map viewport to the list without changing the map's canonical studio set. */
    Location.prototype.filterStudios = function (studiosToBeShown) {
        this.studioIdsInMapViewport = new Set(studiosToBeShown.map(function (studio) { return String(studio.id); }));
        this.updateRenderedStudios();
    };
    Location.prototype.updateRenderedStudios = function () {
        this.studios = lodash_1.default.cloneDeep(this.getStudioListCandidates().slice(0, this.maxShowedStudios));
        this.renderStudios();
    };
    Location.prototype.getStudioListCandidates = function () {
        var _this = this;
        var _a;
        var mapConfig = (_a = this.config.get.location) === null || _a === void 0 ? void 0 : _a.map;
        if ((mapConfig === null || mapConfig === void 0 ? void 0 : mapConfig.filterListByViewport) && this.studioIdsInMapViewport) {
            return this.listStudios.filter(function (studio) { var _a; return (_a = _this.studioIdsInMapViewport) === null || _a === void 0 ? void 0 : _a.has(String(studio.id)); });
        }
        return this.listStudios;
    };
    Location.prototype.renderStudios = function () {
        var _a, _b;
        this.generateDefaultStudioList();
        this.modifyDataGetObjects();
        (0, studio_selection_util_1._HideAndShowHardcodedStudioLocations)(this.config, this.studios);
        if ((_a = (0, cash_dom_1.default)('[data-location]')) === null || _a === void 0 ? void 0 : _a.length) {
            var showMoreButton = this.createShowMoreButton();
            if (showMoreButton) {
                (0, cash_dom_1.default)((0, cash_dom_1.default)('[data-location]')[(0, cash_dom_1.default)('[data-location]').length - 1]).after(showMoreButton);
            }
        }
        if (this.studioSelectionMap) {
            var mapConfig = (_b = this.config.get.location) === null || _b === void 0 ? void 0 : _b.map;
            var studiosForMap = (mapConfig === null || mapConfig === void 0 ? void 0 : mapConfig.syncMapWithVisibleList) && !mapConfig.filterListByViewport ? this.studios : this.backupStudios;
            this.studioSelectionMap.load(studiosForMap, { lat: this.userLatitude, lon: this.userLongitude });
        }
        this.fireChangeEvent();
    };
    Location.prototype.validateMapSynchronization = function () {
        var _a;
        var mapConfig = (_a = this.config.get.location) === null || _a === void 0 ? void 0 : _a.map;
        if ((mapConfig === null || mapConfig === void 0 ? void 0 : mapConfig.filterListByViewport) && mapConfig.syncMapWithVisibleList) {
            console.warn('filterListByViewport and syncMapWithVisibleList are mutually exclusive. ' +
                'filterListByViewport takes precedence and the map will continue to show all studios.');
        }
    };
    Location.prototype.resetListStudios = function () {
        var _this = this;
        var hasUserPosition = Number.isFinite(this.userLatitude) && Number.isFinite(this.userLongitude);
        if (hasUserPosition) {
            this.backupStudios.forEach(function (a) {
                a.distanceToUser =
                    Math.round((0, helper_const_1._EarthDistance)(+_this.userLatitude, +_this.userLongitude, +a.address.latitude, +a.address.longitude) * 10) /
                        10;
            });
        }
        this.listStudios = lodash_1.default.cloneDeep(this.backupStudios);
        if (hasUserPosition) {
            this.listStudios = this.listStudios.sort(function (a, b) { return a.distanceToUser - b.distanceToUser; });
        }
    };
    Location.prototype.createShowMoreButton = function () {
        var _this = this;
        var candidateCount = this.getStudioListCandidates().length;
        if (this.maxShowedStudios < candidateCount && this.studios.length < candidateCount) {
            (0, cash_dom_1.default)('.show-more-button').remove();
            var cloneObject = this.elementGenerator.getRow({
                html: translation_1.default.t('SHOW MORE'),
                class: 'location-picker show-more-button show-more-button-css',
            });
            // if (this.config.get?.location?.showMoreRefObject) {
            //   cloneObject = this.helper.createClonesForRefObjectId(
            //     [{ key: 'class', value: 'show-more-button' }],
            //     '#' + this.config.get.location.showMoreRefObject
            //   );
            // }
            return cloneObject.on('click', function () {
                _this.showMore();
            });
        }
        else {
            (0, cash_dom_1.default)('.show-more-button').remove();
        }
    };
    Location.prototype.createLocationSearchShowMoreButton = function (data) {
        var _this = this;
        if (this.maxShowedSearchResults < data.length) {
            (0, cash_dom_1.default)('.search-show-more-button').remove();
            var cloneObject = this.elementGenerator.getRow({
                html: translation_1.default.t('SHOW MORE'),
                class: 'm-row search-result-picker search-show-more-button',
            });
            // if (this.config.get?.location?.showMoreRefObject) {
            //   cloneObject = this.helper.createClonesForRefObjectId(
            //     [{ key: 'class', value: 'show-more-button' }],
            //     '#' + this.config.get.location.showMoreRefObject
            //   );
            // }
            return cloneObject.on('click', function () {
                console.log('Show more search results');
                _this.showMoreSearchResults();
            });
        }
        else {
            (0, cash_dom_1.default)('.search-show-more-button').remove();
        }
    };
    Location.prototype.selectStudio = function (studio, options) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioId, studio.id);
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioName, studio.studioName);
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioCountryCode, (_a = studio.address) === null || _a === void 0 ? void 0 : _a.countryCodeAlpha2);
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioAddress, "".concat((_b = studio.address) === null || _b === void 0 ? void 0 : _b.street, " ").concat(studio.address.houseNumber, " ").concat(studio.address.zipCode, " ").concat(studio.address.city));
                        if (studio === null || studio === void 0 ? void 0 : studio.tenantId) {
                            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.tenantId, studio.tenantId);
                        }
                        // Save OID too for yond
                        if (studio.yondStudioOid) {
                            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._YondMapping.studioOid, studio.yondStudioOid);
                            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._YondMapping.legalEntityOid, studio.yondLegalEntitiyOid);
                            if ((_c = studio.yondLegalEntityName) === null || _c === void 0 ? void 0 : _c.length) {
                                (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._YondMapping.legalEntityName, studio.yondLegalEntityName);
                            }
                            if ((_d = studio.yondAGBUrl) === null || _d === void 0 ? void 0 : _d.length) {
                                (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._YondMapping.agbUrl, studio.yondAGBUrl);
                            }
                        }
                        // update hidden fields on page
                        (0, input_output_helper_const_1._PrefillHiddenFields)();
                        this.fireSelectionEvent({
                            event: options.event,
                            element: options.element,
                            location: studio.id,
                            name: studio.studioName,
                        });
                        // V2 Communication that studio was selected
                        this.communicationService.sendEvent({
                            event: 'custom',
                            module: this,
                            name: 'studioSelected',
                            value: true,
                        });
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.trackerService.trackFunnelEvent(this.config, 'studioSelected')];
                    case 2:
                        _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _g.sent();
                        console.error('studioSelected tracking failed', e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (options.continueToNextStep && ((studio === null || studio === void 0 ? void 0 : studio.redirect) || ((_e = this.config.get) === null || _e === void 0 ? void 0 : _e.redirect))) {
                            window.location.href = (_f = studio.redirect) !== null && _f !== void 0 ? _f : this.config.get.redirect;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Location.prototype.generateDefaultStudioList = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((0, cash_dom_1.default)('#location-wrapper').length === 0 && ((_c = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.locationWrapper) === null || _b === void 0 ? void 0 : _b.domElement) === null || _c === void 0 ? void 0 : _c.length) === 0) {
            console.error('NO LOCATION WRAPPER FOUND PLEASE ADD #location-wrapper or data-ref="location-wrapper" for search results');
            return;
        }
        var studiosHtml = [];
        var _loop_2 = function (studio) {
            //default solid styling
            var innerHtml = "\n      <div style=\"display:flex;flex-direction:column\">\n        <strong>".concat(studio.studioName, "</strong>\n        <span>").concat(studio.address.street, " ").concat(studio.address.houseNumber, ", ").concat(studio.address.zipCode, " ").concat(studio.address.city, "</span>\n      </div>\n      <div style=\"display:flex;flex-direction:column\">\n        <strong><i>").concat(translation_1.default.t('Choose studio'), "</i></strong>\n        ").concat((studio === null || studio === void 0 ? void 0 : studio.distanceToUser) ? '<span>' + studio.distanceToUser + 'km</span>' : '', "\n      </div>");
            var html = this_2.elementGenerator.getRow({
                html: innerHtml,
                class: 'location-picker',
            });
            // A studio tag can select a different location template and redirect.
            // If multiple configured tags match, the later settings entry wins.
            var tagSettings = this_2.getStudioTagSettings(studio);
            if (tagSettings === null || tagSettings === void 0 ? void 0 : tagSettings.redirect) {
                studio.redirect = tagSettings.redirect;
            }
            // You can define overwrites for certain studios, like redirect url for certain studios
            var overwrites = (_g = (_f = (_e = (_d = this_2.config) === null || _d === void 0 ? void 0 : _d.get) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.studioOverwrites) === null || _g === void 0 ? void 0 : _g[studio.id];
            if (overwrites) {
                (0, helper_const_1._DeepMerge)(studio, overwrites);
                console.log('applied studio overwrites for studio', studio.id, ':', overwrites, 'final studio', studio);
            }
            var requestedRefObjectId = (_h = tagSettings === null || tagSettings === void 0 ? void 0 : tagSettings.refObjectId) !== null && _h !== void 0 ? _h : (_j = this_2.config.get) === null || _j === void 0 ? void 0 : _j.refObjectId;
            var templateReference = this_2.getStudioTemplateReference(requestedRefObjectId);
            var copiedObject = (_k = templateReference === null || templateReference === void 0 ? void 0 : templateReference.cloneDomElement) === null || _k === void 0 ? void 0 : _k.call(templateReference);
            if (copiedObject === null || copiedObject === void 0 ? void 0 : copiedObject.length) {
                this_2.replaceDataAttributes(copiedObject, studio);
                copiedObject.css('display', 'flex');
                html = copiedObject;
            }
            studiosHtml.push(html.on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.selectStudio(studio, {
                                continueToNextStep: true,
                                event: event,
                                element: html,
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }));
        };
        var this_2 = this;
        for (var _i = 0, _l = this.studios; _i < _l.length; _i++) {
            var studio = _l[_i];
            _loop_2(studio);
        }
        var moreButton = this.createShowMoreButton();
        if (moreButton) {
            studiosHtml.push(moreButton);
        }
        if (this.config.get.section === 'v2') {
            this.module.references.locationWrapper.domElement.html('');
            for (var _m = 0, studiosHtml_1 = studiosHtml; _m < studiosHtml_1.length; _m++) {
                var el = studiosHtml_1[_m];
                this.module.references.locationWrapper.domElement.append(el);
            }
        }
        else {
            (0, cash_dom_1.default)('#location-wrapper').html('');
            for (var _o = 0, studiosHtml_2 = studiosHtml; _o < studiosHtml_2.length; _o++) {
                var el = studiosHtml_2[_o];
                (0, cash_dom_1.default)('#location-wrapper').append(el);
            }
        }
    };
    /** Registers configured tag templates so they use the same cloning behavior as regular module references. */
    Location.prototype.initializeStudioTagTemplateReferences = function () {
        var _this = this;
        var _a, _b, _c;
        var studioTagSettings = (_a = this.config.get.location) === null || _a === void 0 ? void 0 : _a.studioTags;
        if (!studioTagSettings)
            return;
        this.studioTagTemplateReferences.clear();
        var defaultLocationReference = (_b = this.module.references) === null || _b === void 0 ? void 0 : _b.location;
        var defaultReferenceIds = new Set([defaultLocationReference === null || defaultLocationReference === void 0 ? void 0 : defaultLocationReference.uid, defaultLocationReference === null || defaultLocationReference === void 0 ? void 0 : defaultLocationReference.legacy, this.config.get.refObjectId].filter(function (id) {
            return Boolean(id);
        }));
        var registeredReferenceIds = new Set();
        Object.values((_c = this.module.references) !== null && _c !== void 0 ? _c : {}).forEach(function (reference) {
            if (reference.uid)
                registeredReferenceIds.add(reference.uid);
            if (reference.legacy)
                registeredReferenceIds.add(reference.legacy);
        });
        var configuredTemplateIds = new Set();
        Object.values(studioTagSettings).forEach(function (settings) {
            if (settings.refObjectId)
                configuredTemplateIds.add(settings.refObjectId);
        });
        var dynamicReferences = {};
        configuredTemplateIds.forEach(function (refObjectId, index) {
            if (defaultReferenceIds.has(refObjectId) || registeredReferenceIds.has(refObjectId))
                return;
            dynamicReferences["studioTagLocation".concat(index)] = {
                uid: refObjectId,
                legacy: refObjectId,
                description: "Location template for studio tag (".concat(refObjectId, ")"),
            };
        });
        (0, reference_object_const_1._RefObjectFinder)(this.$container, dynamicReferences);
        Object.values(dynamicReferences).forEach(function (reference) {
            var _a;
            if ((_a = reference.domElement) === null || _a === void 0 ? void 0 : _a.length) {
                _this.studioTagTemplateReferences.set(reference.uid, reference);
            }
        });
    };
    Location.prototype.getStudioTagSettings = function (studio) {
        var _a;
        var studioTagSettings = (_a = this.config.get.location) === null || _a === void 0 ? void 0 : _a.studioTags;
        if (!studioTagSettings || !studio.studioTags)
            return;
        var studioTagNames = new Set(Array.isArray(studio.studioTags) ? studio.studioTags.map(function (tag) { return tag.name; }) : [studio.studioTags]);
        var matchingTagName;
        Object.keys(studioTagSettings).forEach(function (tagName) {
            if (studioTagNames.has(tagName))
                matchingTagName = tagName;
        });
        return matchingTagName ? studioTagSettings[matchingTagName] : undefined;
    };
    Location.prototype.getStudioTemplateReference = function (refObjectId) {
        var _a, _b;
        if (!refObjectId)
            return (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.location;
        var tagTemplateReference = this.studioTagTemplateReferences.get(refObjectId);
        if (tagTemplateReference)
            return tagTemplateReference;
        var defaultLocationReference = (_b = this.module.references) === null || _b === void 0 ? void 0 : _b.location;
        var isDefaultReference = refObjectId === this.config.get.refObjectId ||
            refObjectId === (defaultLocationReference === null || defaultLocationReference === void 0 ? void 0 : defaultLocationReference.uid) ||
            refObjectId === (defaultLocationReference === null || defaultLocationReference === void 0 ? void 0 : defaultLocationReference.legacy);
        if (!isDefaultReference && this.config.get.environment === 'dev') {
            console.warn("Location template '".concat(refObjectId, "' was not found; using the default location template."));
        }
        return defaultLocationReference;
    };
    /**
     * Finds [data-location] objects on the page and allows to use [data-get] attributes on children
     */
    Location.prototype.modifyDataGetObjects = function () {
        var _this = this;
        var locations = (0, cash_dom_1.default)('[data-location]');
        if (locations.length) {
            locations.each(function (index, location) {
                var id = location.getAttribute('data-location');
                if (id === null || id === void 0 ? void 0 : id.length) {
                    var studio = _this.backupStudios.find(function (studio) { return String(studio.id) === id; });
                    if (studio) {
                        _this.replaceDataAttributes((0, cash_dom_1.default)(location), studio);
                    }
                }
            });
        }
    };
    Location.prototype.replaceDataAttributes = function (copiedObject, studio) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var childrenWithAttributes = copiedObject.find('[data-get]').get();
        if (childrenWithAttributes.length) {
            for (var _i = 0, childrenWithAttributes_1 = childrenWithAttributes; _i < childrenWithAttributes_1.length; _i++) {
                var child = childrenWithAttributes_1[_i];
                var attribute = child.getAttribute('data-get');
                if (attribute === 'displayAdress') {
                    var city = ((_a = studio === null || studio === void 0 ? void 0 : studio.address) === null || _a === void 0 ? void 0 : _a.city) || '';
                    if (city.length && ((_b = studio === null || studio === void 0 ? void 0 : studio.address) === null || _b === void 0 ? void 0 : _b.zipCode)) {
                        city = studio.address.zipCode + ' ' + city;
                    }
                    var street = ((_c = studio === null || studio === void 0 ? void 0 : studio.address) === null || _c === void 0 ? void 0 : _c.street) || '';
                    if (street === null || street === void 0 ? void 0 : street.length) {
                        if ((_d = studio === null || studio === void 0 ? void 0 : studio.address) === null || _d === void 0 ? void 0 : _d.houseNumber) {
                            street += ' ' + ((_e = studio === null || studio === void 0 ? void 0 : studio.address) === null || _e === void 0 ? void 0 : _e.houseNumber);
                        }
                        if (city === null || city === void 0 ? void 0 : city.length) {
                            street += ', ';
                        }
                    }
                    child.innerHTML = street + city;
                }
                else if (attribute === 'distanceToUser') {
                    if (studio === null || studio === void 0 ? void 0 : studio.distanceToUser) {
                        child.innerHTML = studio.distanceToUser + 'km';
                        child.style.display = null;
                    }
                    else if (((_h = (_g = (_f = this.config.get) === null || _f === void 0 ? void 0 : _f.location) === null || _g === void 0 ? void 0 : _g.distanceToUserErrorMessage) === null || _h === void 0 ? void 0 : _h.length) &&
                        +((_k = (_j = this.config.get) === null || _j === void 0 ? void 0 : _j.location) === null || _k === void 0 ? void 0 : _k.distanceToUserErrorMessage) > 0) {
                        child.innerHTML = this.config.get.location.distanceToUserErrorMessage;
                        child.style.display = null;
                    }
                    else {
                        child.style.display = 'none';
                    }
                }
                else if (child instanceof HTMLImageElement) {
                    var imageUrl = (0, get_1.default)(studio, attribute);
                    if (typeof imageUrl === 'string' && imageUrl.length) {
                        child.src = imageUrl;
                        child.style.display = '';
                    }
                    else {
                        child.removeAttribute('src');
                        child.style.display = 'none';
                    }
                }
                else if ((0, get_1.default)(studio, attribute)) {
                    var html = (0, get_1.default)(studio, attribute);
                    if (typeof html === 'object') {
                        console.info('Your data-get path ends in an [object object]', attribute, ' thats the object: ', Object.keys(html), 'maybe you wanna try: "' + attribute + Object.keys(html)[0] + '" for data-get');
                    }
                    child.innerHTML = html;
                }
                else {
                    console.error('your data-get path ', attribute, ' doesnt exist in object');
                }
            }
        }
        else {
            console.error('You didnt specifiy any data-get attributes inside your refobject');
        }
    };
    Location.prototype.showMore = function () {
        this.maxShowedStudios += 3;
        this.updateRenderedStudios();
    };
    Location.prototype.showMoreSearchResults = function () {
        this.maxShowedSearchResults += 5;
        this.maxSearchResults += 20;
        this.getUserLocationByInput(this.lastSearch);
    };
    Location.prototype.addStyle = function () {
        if (this.stylesAdded === false) {
            (0, cash_dom_1.default)('<style>')
                .prop('type', 'text/css')
                .html("\n            .default-loc-box, .location-picker, .search-result-picker{\n                display: flex;\n                min-height: 75px;\n                align-items: center;\n                justify-content: space-between;\n                padding: 20px;\n                box-shadow: 0px 0px 4px #666;\n                margin-bottom: 25px;\n                cursor: pointer;\n            }\n            .show-more-button-css{\n              text-align:center;\n              background: #fff;\n              justify-content: center !important;\n              color: #111;\n            }\n            #search-results-wrapper{\n              display: flex;\n              flex-direction: column;\n              justify-content: center;\n              align-items: center;\n            }\n        ")
                .appendTo('head');
            this.stylesAdded = true;
        }
    };
    return Location;
}());
exports.Location = Location;
